import { render } from "./OidoModalTitle.vue?vue&type=template&id=71a94d4c&scoped=true"
import script from "./OidoModalTitle.vue?vue&type=script&lang=js"
export * from "./OidoModalTitle.vue?vue&type=script&lang=js"

import "./OidoModalTitle.vue?vue&type=style&index=0&id=71a94d4c&scoped=true&lang=css"
import "./OidoModalTitle.vue?vue&type=style&index=1&id=71a94d4c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71a94d4c"]])

export default __exports__